<div class="page-content">
  <h1>{{ entity().title }}</h1>
  <ngx-json-viewer [json]="entity()" [expanded]="false" />
</div>
